import { render, staticRenderFns } from "./ClientsSettings.vue?vue&type=template&id=571a6ce2&"
import script from "./ClientsSettings.vue?vue&type=script&lang=js&"
export * from "./ClientsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports